export function pad(num: number, len = 3): string {
  return String(num).padStart(len, "0");
}

export function nextPowerOfTwo(n: number): number {
  let p = 1; while (p < n) p <<= 1; return p;
}

export function numericId(pid: string): number {
  return parseInt(pid.replace(/\D/g, ""), 10) || 0;
}

export function pickScore(seed: number): string {
  const options = ["21-19", "21-18", "21-17", "21-16", "21-15", "21-14", "21-12"];
  return options[seed % options.length];
}

export function seedingOrder(size: number): number[] {
  if (size === 1) return [1];
  if (size === 2) return [1, 2];
  const half = size / 2;
  const prev = seedingOrder(half);
  const mirror = prev.map(s => size + 1 - s);
  const out: number[] = [];
  for (let i = 0; i < prev.length; i += 2) out.push(prev[i], mirror[i], mirror[i + 1], prev[i + 1]);
  return out;
}


